import { createStore } from "jotai";
import { atomWithStorage } from "jotai/utils";
import ReactGA from "react-ga4";

export const store = createStore();
export * from "./AccessRole";
export * from "./AuthProfile";
export * from "./ClientVersion";
export * from "./DataPool";
export * from "./Nav";
export * from "./Orgs";
export * from "./User";
export * from "./UserConfig";
export * from "./ZitadelOrg";
export { RESET } from "jotai/utils";

export const isAdminViewAtom = atomWithStorage<boolean>(
  "isAdminView",
  true,
  undefined,
  { getOnInit: true },
);

const saveIsAdminView = () =>
  ReactGA.gtag("set", "user_properties", {
    isAdminView: store.get(isAdminViewAtom),
  });
saveIsAdminView();
store.sub(isAdminViewAtom, () => {
  saveIsAdminView();
});
